module.exports = __webpack_public_path__ + "img/notification.d0bd6ec1.png";